import { crmRegistry } from '@/features/crm_system/lib/_core/crmRegistry';
import { CrmSystemIds } from '@/features/crm_system/lib/_core/crmSystem/crmSystem.types.gen';
import { supabase } from '@/lib/supabase/supabaseClient';
import { useGetExportDataProps } from './useGetExportData.types';
import { refineData, transformGetExportDataShape } from './utils';

export const getExportData = async ({
  projectId,
  surveyId,
}: useGetExportDataProps) => {
  const refinedData = await supabase
    .from('project')
    .select(
      `
        *,
        survey(
            *,
            crm_config(*),
            question(
                *,
                response(
                    *,
                    user(
                        *
                    )
                )
            )
        ),
        crm(*),
        organisation!public_project_organisation_id_fkey(*),
        crm_project(*)
        `
    )
    .eq('id', projectId!)
    .eq('survey.id', surveyId!)
    .maybeSingle()
    .throwOnError()
    .then((res) => res.data)
    .then(transformGetExportDataShape)
    .then(refineData);
  const parsedData = await crmRegistry.parseExportData(
    refinedData?.crm.crm_system as CrmSystemIds,
    refinedData
  );
  const res = parsedData ?? refinedData;
  return res;
};
